import { useContext } from 'react';

import { NerisContext } from '@/contexts/NerisContext';

export const useNeris = () => {
  const context = useContext(NerisContext);
  if (!context) {
    throw new Error('useNeris must be used within a NerisContextProvider');
  }
  return context;
};
